<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-10 10:04:51
 * @LastEditors: xgx
 * @LastEditTime: 2023-08-01 16:28:52
-->
<template>
  <div>
    <el-drawer
      title="原文采纳"
      :visible.sync="visibleTwo"
      @closed="closeTwo"
      :destroy-on-close="true"
      size="535px"
      :with-header="true"
    >
       <a-spin :spinning="appLoading">
    <div class="applay-box">
    <div class="title-box">
        <i class="el-icon-info icon-title"></i>
        <div>
          原文采纳是将稿件按原文内容直接推送至目标栏目下，在后台查看时稿件标题前将带有“推送”标签以便于区分；
          原文采纳的稿件，其创作人员所属组织有权力对稿件进行内容编辑，编辑后，目标栏目中的稿件将即时同步。
        </div>
      </div>
    <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">稿件信息</div>
        </div>
        <div class="txt-box">
        <div class="txt">稿件标题</div>
        <div class="txt-two">
            {{itemData.title}}
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">原始栏目</div>
        <div class="txt-two">{{itemData.sourceParentsName}}</div>
      </div>
      
       <div class="txt-box">
        <div class="txt">目标栏目</div>
        <div class="txt-two">
         {{itemData.pushParentsName}}
        </div>
      </div>
      
      
      
    </div>
     <div>
        <div class="title">
          <div class="icon-title"></div>
          <div class="title-txt">采纳设置</div>
        </div>
        <div class="txt-box">
        <div class="txt">自动发布</div>
        <div class="txt-two">
            <el-switch
            active-color="#13ce66"
              v-model="switchValue"
            >
          </el-switch>
          <div class="switch-box">开启时，稿件被采纳后将直接在目标栏目中被发布，关闭时，则需在后台目标栏目中手动点击发布。</div>
        </div>
      </div>
        <div class="txt-box">
        <div class="txt">采纳评分</div>
        <div class="txt-two">
           <div >
              <el-checkbox-group class="score-box" v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox class="item"  v-for="item in arrayData" :label="item.id" :key="item.id">
                  <div class="item-txt">{{item.name}}</div>
                </el-checkbox>
              </el-checkbox-group>
           </div>
        </div>
      </div>
      
       <div class="txt-box">
        <div class="txt">分值计算</div>
        <div class="txt-two">
         +{{numCont}} 分
        </div>
      </div>
    </div>
    </div>
  </a-spin>
    <div class="bottom">
       <div class="form-bottom">
            <el-button @click="closeTwo"   size="small" >关闭</el-button>
            <el-button
              type="primary"
              size="small"
              @click="adoption"
              :loading="loadingShow"
               v-if="codeData.indexOf('366') != -1"
              style="margin-left: 14px"
              >确认采纳</el-button
            >
           
          </div>
    </div>
    </el-drawer>
  </div>
</template>

<script>
import {details,detailsSelectPage,originalAdoption} from './index';
export default {
  data() {
    return {
      visibleTwo: false,
      appLoading: false,
      switchValue:true,
      checkedCities:[],
      numCont:0,
      arrayData:[],
      itemData:{},
      loadingShow:false,
      codeData:[],
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    item:{
      type: Object,
      default: {},
    }
  },
  components: {},
  mounted() {},
  methods: {
    closeTwo() {
      this.$emit('closeTwo')
      this.checkedCities = [];
      this.numCont = 0;
    },
    close(){
      this.$emit('close')
      this.checkedCities = [];
      this.numCont = 0;
    },
    handleCheckedCitiesChange(value){
        let num = 0;
        let arrayData = JSON.parse(JSON.stringify(this.arrayData));
        for (let index = 0; index < arrayData.length; index++) {
          const element = arrayData[index];
          if(this.checkedCities.indexOf(element.id) != -1){
              num = num + element.number;
          }
        }
        this.numCont = num;
    },
    getDeils(){
         this.appLoading = true;
      details({
          id:this.item.id,
        }).then((res)=>{
            if(res.code == 0){
                this.itemData = res.data;
                this.appLoading = false;
            }
        })
    },
    getList(){
        detailsSelectPage({
          current:1,
          size:1000000,
        }).then((res)=>{
            if(res.code == 0){
                this.arrayData = res.data.records;
            } 
        })
    },
    adoption(){
      this.loadingShow = true;
      originalAdoption({
          id:this.itemData.id,
          autoPublish:this.switchValue?1:2,
          scoringCriteria:this.checkedCities.join(',')
      }).then((res)=>{
          if(res.code == 0){
              this.$emit('close')
          }
           this.loadingShow = false;
      })
    }
  },
  created() {},
  watch: {
    visible(val) {
      this.visibleTwo = val;
      if(this.visibleTwo){
          this.getDeils();
          this.getList();
          this.switchValue = this.itemData.autoPublish == 1 ? true : false;
           this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__header {
  border-bottom: solid 1px #ededef;
  padding-bottom: 10px;
  padding-top: 10px;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 14px;
}
.el-drawer__close-btn {
  font-size: 14px;
}
/deep/ .el-drawer {
  border-top-left-radius: 13px;
  border-bottom-left-radius: 13px;
}
/deep/ .el-icon-close {
  font-weight: 600;
}
.applay-box {
  padding: 24px;
  padding-bottom: 20px;
  padding-top: 0px;
  padding-bottom: 100px;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  .icon-title {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: rgba(23, 109, 230, 1);
  }
  .title-txt {
    color: rgba(23, 109, 230, 1);
    font-size: 16px;
    font-family: HarmonyOS_Sans_SC-regular;
    margin-left: 10px;
    font-weight: 600;
  }
}
.txt {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-bold;
  font-weight: 600;
  width: 80px;
}
.txt-two {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  width: 100%;
}
.txt-box {
  margin-bottom: 20px;
  display: flex;
}
.txt-two-img {
  width: 90px;
  height: 90px;
  margin-right: 14px;
  background: #f6f6f6;
  /deep/ .el-image__inner {
    object-fit: contain;
  }
}
/deep/ .el-descriptions--medium.is-bordered .el-descriptions-item__cell {
  padding: 8px;
  &:first-child {
    width: 120px;
  }
}
.label-box {
  width: 300px;
}
.title-box {
  display: flex;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding: 8px 10px;
  color: rgba(144, 147, 153, 1);
  font-size: 13px;
  text-align: left;
  margin-bottom: 16px;
  font-family: HarmonyOS_Sans_SC-regular;
  .icon-title {
    color: #a9aab1;
    transform: rotate(-13deg);
    margin-top: 3px;
    margin-right: 2px;
  }
  /deep/ .anticon-close {
    color: rgba(48, 49, 51, 1);
    font-size: 20px;
    font-weight: bold;
  }
}
.switch-box{
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  font-family: Roboto-regular;
  margin-top: 8px;
}
.score-box{
  width: 417px;
  max-height: 256px;
  overflow-y: auto;
  border-radius: 4px;
  text-align: left;
  border: 1px solid rgba(220, 223, 230, 1);
  margin-top: -10px;
  padding: 8px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
	flex-wrap: wrap;
  /deep/ .el-checkbox__label{
    display: block;
    width: 100%;
    padding-left: 4px;
  }
  /deep/ .el-checkbox__input{
    margin-top: 3px;
  }
  .item {
    width: 42%;
    margin-top: 6px;
    display: flex;
    align-items: center;
    .item-txt{
        overflow: hidden; 
        text-overflow: ellipsis; 
        white-space: nowrap;
        width: 100%;
    }

}
}
.bottom {
  text-align: right;
  position: absolute;
  bottom: 0;
  border-top: solid 1px #e5e7ec;
  width: 100%;
  background: #fff;
  .form-bottom {
    margin-right: 24px;
    padding: 15px 0px;
  }
}
 .el-button--primary {
  background: #176de6;
}
</style>